export enum LegalType {
    Legal = 1,
    Individual = 2,
}
